/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 娱伯牙文章内容搜索查询
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class SearchProductsParams {
  constructor(
    public keyword: string,
    public page: number,
    public size: number
  ) {}
}

export default async function (
  params: SearchProductsParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.YbyContentSearchListVO>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/search-yby-content`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
